import styled from 'styled-components'
import {white} from '@modifi/constants/colors'
import {Row, Col, media, ProgressButton} from '@modifi/ui'

const StyledRow = styled(Row)`
  background: ${white};
  padding: 0 25px;

  ${Col} {
    display: flex;
    align-items: center;
  }
`

export const HeaderRow = styled(StyledRow)`
  display: none;
  font-size: 14px;
  font-weight: 400;
  height: 56px;

  ${Col} {
    text-transform: uppercase;
  }

  ${media.md`
    display: flex;
  `}
`

export const ItemRow = styled(StyledRow)`
  background: ${white};
  transition: box-shadow 0.2s ease;

  &:hover,
  &:focus-within {
    box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.06);
  }

  ${Col} {
    height: 80px;
  }
`

export const transitionPeriod = 300
export const transitionDelay = 300

export const ProgressButtonContent = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  opacity: 1;
`
export const ProgressButtonSuccess = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  transform: rotate3d(0, 1, 0, 90deg);
`

export const StyledProgressButton = styled(ProgressButton)`
  position: relative;
  font-size: 14px;
  text-transform: uppercase;

  & + & {
    margin-left: 60px;
  }

  ${({successStart}) =>
    successStart
      ? `
        ${ProgressButtonContent} {
          transform: rotate3d(0, 1, 0, -90deg);
          opacity: 0;
          transition: all ${transitionPeriod}ms ease;
        }
        
        ${ProgressButtonSuccess} {
          transform: rotate3d(0, 1, 0, 0deg);
          transition: transform ${transitionPeriod}ms ${transitionDelay}ms ease;
        }
      `
      : ''}

  ${({successEnd}) =>
    successEnd
      ? `
        ${ProgressButtonContent} {
          opacity: 1;
          transform: rotate3d(0, 1, 0, 0deg);
          transition: transform 0s, opacity ${3 * transitionPeriod}ms ${transitionPeriod} ease;
        }
        
        ${ProgressButtonSuccess} {
          opacity: 0;
          transition: opacity ${transitionPeriod}ms ease;
        }
      `
      : ''}
`
